<p>
  For more information regarding IT policy on purchasing hardware and software, please see the <a href="http://kfcomputers.web.unc.edu/" class="fw-bold" target="_blank">IT Purchasing</a> page. If you have any questions
  please contact us at <a href="mailto:itorders@kenan-flagler.unc.edu" class="fw-bold">itorders&#64;kenan-flagler.unc.edu</a>.
  <br /><br />
  Your request will be processed in the order it was received.
</p>

<boolean-slider [(obj)]="request" prop="isOtherPurchase"
  label="Purchasing For" [labelCols]="labelCols"
trueLabel="Someone Else" falseLabel="Myself"></boolean-slider>

@if (!!request.isOtherPurchase) {
  <array-builder [(obj)]="request" prop="otherPeople"
    label="Recipient(s)" [labelCols]="labelCols"
    [typeaheadList$]="peopleService.personTypeaheadList$ | typeaheadBinder : peopleService"
    [requireTypeaheadSelection]="true"
  typeaheadFilter="personTypeList=IsActiveEmployee"></array-builder>
}

<text-input [(obj)]="request" prop="reason"
  label="Purchase Reason" [labelCols]="labelCols"
[mode]="inputMode.TextArea"></text-input>

<dropdown [(obj)]="request" prop="type"
  label="Request Type" [labelCols]="labelCols"
  [listOfOptions$]="requestTypes | toListOption | toObservable"
  [invalidValueMode]="invalidValueMode.AllowEnabled"
  [optionsToShow]="1" [maxSelectionCount]="1"
placeholder="Select one"></dropdown>

@if (request.type == 'Computer') {
  <div>
    <hr />
    <div class="alert alert-info">For information about the standard types of computers we offer please see this page: <a href="https://kfcomputers.web.unc.edu/standard-equipment/" class="fw-bold" target="_blank">UNC Kenan-Flagler Computer Options</a>.</div>
    <dropdown [(obj)]="request" prop="computerType"
      label="Computer Type" [labelCols]="labelCols"
      [listOfOptions$]="computerTypes | toListOption | toObservable"
      [invalidValueMode]="invalidValueMode.AllowEnabled"
      [optionsToShow]="1" [maxSelectionCount]="1"
    placeholder="Select one"></dropdown>
    @if (request.computerType == 'Custom Computer') {
      <div class="alert alert-info">Custom computers are not funded by the IT Department and cost code(s) will need to be provided to purchase them. Please include details of the custom computer order in the notes below.</div>
    }
    @if (request.computerType != 'Custom Computer') {
      <dropdown [(obj)]="request" prop="computerOs"
        label="Computer Operating System" [labelCols]="labelCols"
        [listOfOptions$]="computerOsTypes | toListOption | toObservable"
        [invalidValueMode]="invalidValueMode.AllowEnabled"
        [optionsToShow]="1" [maxSelectionCount]="1"
      placeholder="Select one"></dropdown>
      <boolean-slider [(obj)]="request" prop="isItFunded"
        label="This order is for a standard computer for a full-time employee and it is requested that IT cover the cost."
        [labelCols]="12"
      trueLabel="Yes" falseLabel="No"></boolean-slider>
    }
    <hr />
  </div>
}

@if (request.type == 'Software') {
  <div>
    <hr />
    <text-input [(obj)]="request" prop="softwareTitle"
    label="Software Title" [labelCols]="labelCols"></text-input>
    <text-input [(obj)]="request" prop="softwareVersion"
    label="Software Version" [labelCols]="labelCols"></text-input>
    <dropdown [(obj)]="request" prop="softwareOs"
      label="Software Operating System" [labelCols]="labelCols"
      [listOfOptions$]="swOsTypes | toListOption | toObservable"
      [invalidValueMode]="invalidValueMode.AllowEnabled"
      [optionsToShow]="1" [maxSelectionCount]="1"
    placeholder="Select one"></dropdown>
    <div class="alert alert-info">All software requests will be reviewed for sensitive data use.  <a href="https://safecomputing.unc.edu/data/sensitive-information/" class="fw-bold" target="_blank">What is sensitive information?</a></div>
    <hr />
  </div>
}

<text-input [(obj)]="request" prop="costCode"
  label="Cost Code" [labelCols]="labelCols"
  [mode]="inputMode.Text" [displayFormat]="formatter.CostCode">
</text-input>

<text-input [(obj)]="request" prop="notes"
  label="{{request.type == 'Other' ? 'Describe Your Request' : 'Additional Notes'}}"
  [labelCols]="labelCols"
[mode]="inputMode.TextArea"></text-input>

<div>
  <file-upload [(obj)]="request" prop="file"
    label="Attachments"
    [labelCols]="labelCols"
    (fileSelected)="addFile($event)"
  helpText="Max file size 4MB"></file-upload>
  @if (!!request.files?.length) {
    @for (file of request.files; track file; let i = $index) {
      <div class="offset-{{labelCols}} mb-2">
        <div class="border border-1 border-dark rounded bg-light d-flex justify-content-between px-2 mt-1 me-1 text-break"
          [style.width]="'fit-content'">
          <div title="{{file.name}}">{{file.displayName}}</div>
          <button type="button" class="btn btn-xs ms-2 p-0 fw-bold h-auto" (click)="removeFile(i)" title="Remove">X</button>
        </div>
      </div>
    }
  }
</div>

@if (purchase$ | async) {
}
<button type="button" class="btn btn-primary" [disabled]="request.hasErrors || isSubmitting" (click)="submit()">Submit @if (isSubmitting) {
  <i class="fa-solid fa-circle-notch fa-spin ms-1"></i>
}</button>

